import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import AlertContext from "../../../../Context/Alert/AlertContext";

const PortfolioSuccess = () => {
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleBackToProfile = async () => {
    try {
      setIsLoading(true);
      navigate("/user-dashboard/profile/");
    } catch (error) {
      showAlert("Navigation failed. Please try again.", "danger");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4
             ${theme == "dark" ? "bg-black text-white" : "bg-white"}`}
      >
        <h1
          className={`font-semibold text-xl
                  ${theme == "dark" && "text-white"}`}
        >
          Portfolio check
        </h1>
        <div className="flex flex-col gap-4">
          <p
            className={`text-lightGrey
                      ${theme == "dark" && "text-white"}`}
          >
            We are reviewing your Portfolio. This may take up to 2 days...
          </p>
          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent font-medium font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white
                      ${
                        theme === "dark"
                          ? "hover:text-white"
                          : "hover:text-black"
                      }
                      ${
                        isLoading
                          ? "opacity-50 cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
            onClick={handleBackToProfile}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              </div>
            ) : (
              "Back to profile"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSuccess;
